<template>
  <div>
    <el-form
      @submit.native.prevent="onSubmitCalcular"
      :model="dados"
      ref="dados"
      label-position="top"
    >
      <div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
              <el-form-item key="periodo" label="Ano Letivo">
                  <el-select v-model="dados.ano">
                      <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Ano Letivo ' + item.nome" :value="item.nome"></el-option>                     
                  </el-select>
              </el-form-item>
          </el-col>
        </el-row>  
        <el-row :gutter="10">  
          <el-col :xs="24" :sm="8" :md="8" class="u-mt-15">
            <el-form-item label="Data de Nascimento" key="data_nascimento">                
                <el-input v-model="dados.data_nascimento" v-mask="'##/##/####'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10"></el-row>        
          <el-col :xs="24" :sm="12" :md="12" v-if="dados.idade">
            <div label="Idade Letiva" key="idade" style="font-size: 16px">A Idade Letiva do aluno no ano de {{ this.dados.ano }} é:  {{ dados.idade }} anos</div>
          </el-col>  
        </el-row>       
        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-5">
              <el-button type="primary" id="btn-modelo" native-type="submit"
                >CALCULAR</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dados: {       
        ano: "",
        data_nascimento: "",
        idade: ""
      },
    };
  },
  mounted () {

    this.dados.ano = JSON.parse(JSON.stringify(this.$store.state.config.periodo.nome));

  },
  methods: {
    calculaIdade() {    

      let dtNascimento = this.dados.data_nascimento
        .split("/")
        .reverse()
        .join("-");
      let idadeCalculada = this.$moment(`${this.dados.ano}-03-31`).diff(
        dtNascimento,
        "years"
      );

      console.log(idadeCalculada);

      this.dados.idade = idadeCalculada;     
     
    },
    onSubmitCalcular() {
      this.calculaIdade()      
    },
    
  },
};
</script>
